import { useCallback, useEffect } from "react";

import { VIDEO }             from "_common/utils";
import { formatLiveSession } from "_common/utils/broadcast";

export const useScrollAnimation = ( { imageRef, statsRef, headerContainerRef, isMobile } ) => {

	const func = useCallback ( () => {
		if ( isMobile )
			return;

		// Get the current scrollY point
		const sY = window.scrollY;

		const dimentionInPixel = 90;

		imageRef.current.style.width       = `calc(9rem - ${ Math.min ( sY, dimentionInPixel ) }px)`;
		imageRef.current.style.height      = `calc(9rem - ${ Math.min ( sY, dimentionInPixel ) }px)`;
		imageRef.current.style.marginRight = `calc(2rem - ${ Math.min ( sY, 15 ) }px)`;

		// not using anymore
		// statsRef.current.style.opacity =  1 - sY/100 > 0 ? 1 - sY/100 : 0;
		// statsRef.current.style.height  = 17 - sY > 0 ? `${ 17-sY }px` : 0;

		headerContainerRef.current.style.marginBottom = `calc(2rem - ${ Math.min ( sY, 20 ) }px)`;

		// Get a padding percentage (we want 100% with 0 scroll and 0% with 250 or + scroll)
		// const percent = 100 - ( sY >= maxScrollFor100 ? 100 : sY / ( maxScrollFor100 / 100 ) );

	}, [ imageRef, statsRef, headerContainerRef, isMobile ] );

	useEffect ( () => {
		window.addEventListener ( "scroll", func, { passive: true } );

		  return () => {
			window.removeEventListener ( "scroll", func );
		  };
	}, [ isMobile ] );
};

export const formatFeeds = ( list = [] ) => {
	return list.map ( item => ( {
		id        : item?.id,
		createdAt : item?.created_at,
		title     : item?.title,
		userData  : {
			id          : item?.actor_details_v2?.id,
			name        : item?.actor_details_v2?.name,
			photo       : item?.actor_details_v2?.photo,
			isCeleb     : item?.actor_details_v2?.isCeleb,
			isFollowing : item?.actor_details_v2?.isFollowing
		},
		thumbnail     : item?.media?.find ( el => el?.media_sequence === "2" )?.href || "",
		src           : item?.media?.find ( el => el?.media_sequence === "3" )?.href || "",
		videoDuration : item?.read_time,
		views         : item?.views_count, // totalViews, views are already there, not confirm which one should be used
		feedType      : VIDEO
	} ) );
};

export const formatLiveVideoFeeds = ( list = [] ) => {
	return list.map ( item => formatLiveSession ( item ) );
};